module.exports = [{"value":"ตรวจด้วยตัวเอง(ATK)","text":"ตรวจด้วยตัวเอง(ATK)"},{"value":"ตรวจที่โรงพยาบาล","text":"ตรวจที่โรงพยาบาล"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/master/vaccine/typeCheckCovid2.json
// module id = Yhzh
// module chunks = 2